// extracted by mini-css-extract-plugin
module.exports = {"topbar":"EmptyBotPage_topbar__1v-dH","topbar__logo":"EmptyBotPage_topbar__logo__1IPxF"};